export default __webpack_public_path__ + "static/media/adminStaff.9a3c392c.svg";